import { z } from "zod";

import { MaterialPriceAlertSchema } from "./MaterialPriceAlert";

/**
 * Error codes for material upload validation
 */
export enum MaterialUploadErrorCode {
  // File errors
  EMPTY_FILE = "EMPTY_FILE",
  FILE_TOO_BIG = "FILE_TOO_BIG",
  INVALID_FILE_TYPE = "INVALID_FILE_TYPE",
  CSV_PARSING_FAILED = "CSV_PARSING_FAILED",

  // Structure errors
  COLUMN_MISSING = "COLUMN_MISSING",
  MISSING_FIELD = "MISSING_FIELD",
  NO_ROW_IMPORTED = "NO_ROW_IMPORTED",

  // Validation errors
  INVALID_NUMBER = "INVALID_NUMBER",
  INVALID_PRICE = "INVALID_PRICE",
  INVALID_LENGTH = "INVALID_LENGTH",
  INVALID_WIDTH = "INVALID_WIDTH",
  INVALID_HEIGHT = "INVALID_HEIGHT",
  INVALID_TUBE_THICKNESS = "INVALID_TUBE_THICKNESS",
  INVALID_DENSITY = "INVALID_DENSITY",
  INVALID_GRADE = "INVALID_GRADE",
  INVALID_TYPE = "INVALID_TYPE",
  INVALID_ALLOY = "INVALID_ALLOY",

  // Business logic errors
  COMPANY_NOT_FOUND = "COMPANY_NOT_FOUND",
  NO_SUPPLIER = "NO_SUPPLIER",
  DATABASE_ERROR = "DATABASE_ERROR",

  // Network errors
  NETWORK_ERROR = "NETWORK_ERROR",

  // Generic
  GENERIC = "GENERIC",
}

export const MaterialUploadErrorSchema = z.object({
  code: z.nativeEnum(MaterialUploadErrorCode),
  message: z.string(),
  row: z.number().optional(),
  field: z.string().optional(),
  value: z.string().optional(),
  context: z.record(z.string()).optional(),
});

export type MaterialUploadError = z.infer<typeof MaterialUploadErrorSchema>;

export const MaterialUploadResponseSchema = z.object({
  success: z.boolean(),
  errors: z.array(MaterialUploadErrorSchema).optional(),
  alerts: z.array(MaterialPriceAlertSchema).optional(),
});

export type MaterialUploadResponse = z.infer<typeof MaterialUploadResponseSchema>;
